import { useCallback, useEffect, useState } from 'react';
import {
  fetchInventoryMovements,
  type InventoryMovement,
} from '@/services/inventory';

export function useInventoryMovements() {
  const [movements, setMovements] = useState<InventoryMovement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchInventoryMovements()
      .then((res) => {
        if (cancelled) return;
        setMovements(res.movements);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'Error al cargar los movimientos');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => load(), [load]);

  return { movements, loading, error, refetch: load };
}